<template>
  <div v-if="this.item">
    <div class="fixed bottom-0 right-0 z-70 w-full h-screen grid" id="js_quick_view" style="display: grid;">
      <div class="bg-black/70 cursor-pointer grid-area w-full h-full js_close_quick_view"></div>

      <div class="relative w-full h-fit bg-white px-s20 py-s20 flex flex-col grid-area gap-s20 self-end m_580:self-center justify-self-center m_580:w-s400 m_1200:py-s40 m_1200:px-s60 m_1200:gap-s60 m_800:flex-row m_800:px-s50 m_800:py-s30 m_800:gap-s50 m_800:w-fit quick_view_content">
        <button type="button" class="text-black absolute top-s20 right-s20 m_800:top-s30 m_800:right-s30 js_close_quick_view">
          <close-icon svgClassName="size-s25 pointer-events-none"></close-icon>
        </button>

        <div class="mx-auto self-start w-s180 m_800:w-s200 m_1000:w-[260px] m_1200:w-[338px]" v-if="images.length > 0">
          <vue-slick-carousel :arrows="true" :draggable="false" :lazyLoad="ondemand">
            <div>
              <img :src="item.thumbnail_large" :alt="item.title" class="w-full" width="300" height="455">
            </div>
            <div v-for="(item, index) in images" :key="index">
              <img :src="getResized(item)" :alt="item.title" class="w-full" width="300" height="455">
            </div>
          </vue-slick-carousel>
        </div>

        <div v-else class="mx-auto self-start w-s180 m_800:w-s200 m_1000:w-[260px] m_1200:w-[338px]">
          <div>
            <img :src="item.thumbnail_large" :alt="item.title" class="w-full" width="300" height="455">
          </div>
        </div>

        <div class="bg-white w-fit mx-auto text-center m_800:text-left m_800:w-s400 m_1200:w-[500px]">
          <p class="text-t14 text-center font-semibold uppercase m_800:text-t20 m_800:text-left m_1200:text-t24">
            {{ item.brend.title }}
          </p>
          <h2 class="text-t14 text-center mb-s20 m_800:text-t20 m_800:text-left m_1200:text-t26">{{ item.title }}</h2>
          <p class="w-5/6 text-t14 hidden m_1200:text-t16 m_800:block">
            {{ item.desc }}
          </p>
          <div v-if="checkForDiscounts()">
            <p class="text-t16 text-dark-gray line-through mt-s15 mb-s20 hidden m_800:block m_1200:text-t20 m_1200:mt-s20 m_1200:mb-s40">
              {{ formatPrice(item.price_outlet) }} RSD
            </p>

            <div class="hidden m_800:flex">
              <div class="odd:bg-red even:bg-black rounded-full size-s50 grid place-items-center m_1200:size-s60" v-if="item.first_discount > 0">
                <p class="text-white text-t16 m_1200:text-t18">-{{ item.first_discount }}%</p>
              </div>
              <div class="odd:bg-red even:bg-black rounded-full -ml-s10 size-s50 grid place-items-center m_1200:size-s60" v-if="item.second_discount > 0">
                <p class="text-white text-t16 m_1200:text-t18">-{{ item.second_discount }}%</p>
              </div>
            </div>
          </div>

          <p class="text-t20 font-medium mt-s15 hidden m_800:block m_1200:text-t24 m_1200:mt-s20"
            :class="checkForDiscounts() ? 'text-red' : 'text-black'">
            {{ formatPrice(item.finalPrice) }} RSD
          </p>

          <div class="hidden gap-s10 items-center my-s15 m_800:flex m_1200:my-s20">
            <div class="bg-green rounded-full size-s15 m_1200:size-s20"></div>
            <p class="text-green uppercase mt-s3 text-t14 m_1200:text-t16">Proizvod je na stanju</p>
          </div>

          <p class="pb-s10 text-t14 m_1200:text-t16">Izaberite veličinu:</p>

          <ul class="flex gap-s5 pb-s10 flex-wrap justify-center m_800:pb-s15 m_800:justify-start m_1200:gap-s10 m_1200:pb-s20">
	          <li v-for="(size, index) in sizes" :key="index">
		          <button v-if="sizes.length === 1" @click="getSelectedSize(size)" class="px-s15 py-s10 text-t12 grid place-items-center bg-black text-white border border-black cursor-pointer m_1000:hover:bg-black m_1000:hover:text-white m_1000:transition-colors m_1000:duration-200 m_1200:px-s20 m_1200:py-s10 m_1200:text-t14 js_get_selected_size">
		            {{ selectOneSize() }} {{ size }}
	            </button>

              <button v-else @click="getSelectedSize(size)" class="px-s15 py-s10 text-t12 grid place-items-center border border-black cursor-pointer m_1000:hover:bg-black m_1000:hover:text-white m_1000:transition-colors m_1000:duration-200 m_1200:px-s20 m_1200:py-s10 m_1200:text-t14 js_get_selected_size">
                {{ size }}
              </button>
            </li>
          </ul>

          <p id="message" class="text-red text-t14 font-medium" style="display:none">Izaberite veličinu.</p>

	        <p v-if="checkCategoryUnderwear()" style="color: red">Ovaj proizvod ne može biti zamenjen/vraćen iz higijenskih razloga</p>

          <div class="w-fit grid gap-s10 items-center mx-auto pt-s10 m_800:mx-0 m_800:flex m_800:pt-s15  m_1200:pt-s20">
            <div class="max-w-fit mx-auto">
              <add-to-cart
	              :price="item.finalPrice"
	              :size="selectedSize"
	              :product="item">
              </add-to-cart>
            </div>

            <a :href="item.path">
              <button type="button" id="js_find_store"
                class="min-w-s180 max-w-fit hidden items-center text-t14 bg-white text-black py-s10 px-s20 uppercase border border-black m_800:grid m_1000:hover:border-light-gray m_1000:hover:bg-light-gray m_1000:transition-colors m_1000:duration-200 m_1200:text-t16 m_1200:px-s40 m_1200:min-w-s200">
                Detaljnije
              </button>
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "../svg/CloseIcon.vue";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import accounting from 'accounting';
import { EventBus } from '.././eventBus.js';

export default {
  components: {
    CloseIcon,
    VueSlickCarousel
  },
  data() {
    return {
      selectedSize: '',
      sizes: [],
      images: [],
      ondemand: 'ondemand',
    };
  },
  props: [
    'item',
  ],
  created() {
    axios
        .get(`/getProductData/${this.item.id}`, )
        .then(response => {
          this.sizes = response.data.sizes;
          this.images = response.data.images;
        })
        .catch(error => {
          console.log(error)
        })
  },
  mounted() {
    document.addEventListener('click', this.handleCloseQuickViewClick);
    document.addEventListener('keydown', this.handleEscapePress);

    EventBus.$on('show-message', () => {
      const hide = document.getElementById('message');
      hide.style.display = 'block';
    });

    // document.body.classList.add('no_scroll');
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleCloseQuickViewClick);
    document.removeEventListener('keydown', this.handleEscapePress);

    // document.body.classList.remove('no_scroll');

		this.selectedSize = null;

  },
  methods: {
    handleCloseQuickViewClick(event) {
      if (event.target.classList.contains('js_close_quick_view')) {
        this.hideQuickView();
      }
    },
    handleEscapePress(event) {
      if (event.key === 'Escape') {
        this.hideQuickView();
      }
    },
    hideQuickView() {
      const toAppearQuickView = document.getElementById('js_quick_view');
      toAppearQuickView.style.display = 'none';
      this.$parent._data.showQuickView = false;
    },
    formatPrice(value) {
      return accounting.formatMoney(value, '', 2, '.', ',')
    },
    getSelectedSize(size) {
      this.selectedSize = size;

      const sizeElements = document.querySelectorAll('.js_get_selected_size');
      sizeElements.forEach(element => {
        if (element.textContent.trim() === size) {
          element.classList.add('bg-black', 'text-white');
        } else {
          element.classList.remove('bg-black', 'text-white');
        }
      });
    },
    /**
	   * Create link for desktop gallery images.
	   *
	   * @param item
	   * @returns {string}
	   */
    getResized(item){
      const words = item.split('/images/');
      let middle = '/resized/medium/images/'

      return words[0] + middle + words[1];
    },

    checkForDiscounts() {
	    return this.item.first_discount > 0 || this.item.second_discount > 0;
    },

	  /**
	   * Select size when there is only 1 size availabile.
	   */
	  selectOneSize() {
		  this.selectedSize = this.sizes[0];
	  },

	  checkCategoryUnderwear() {

		  let categoryUnderwearIds = [169, 128, 1133, 142, 938, 116, 1110, 1123];

			let categories = this.item.categories;

			return categories.some(category =>
				categoryUnderwearIds.includes(category.id)
			);

	  }
  },
};
</script>

<style scoped>
.active_quick_view{animation:quickView linear 500ms;animation-iteration-count:1;animation-fill-mode:forwards}@keyframes quickView{0%{opacity:0}100%{opacity:1}}
</style>